<template>
  <div class="h-results">
    <div class="banner mb-3">
      <img src="@/assets/banner/jp.png">
    </div>

    <div class="h-head">
      <h2 class="m-0"><img src="@/assets/theme/icon32.png"> Past Dow Jones TV Results</h2>
    </div>
    <div class="h-body">
      <div class="row h-box" v-for="(item, index) in items" :key="index">
        <div class="col-md-6 h-date">
          {{ item.lotto_date | date }}
        </div>
        <div class="col-md-6 h-number">
          <span v-for="(n, rindex) in splitResult(item.results)" :key="index+`-`+rindex">{{n}}</span>
        </div>
      </div>
    </div>

    <div class="banners row">
      <div class="col-md-4 banner">
        <img src="@/assets/banner/b1.png">
      </div>
      <div class="col-md-4 banner">
        <img src="@/assets/banner/b2.png">
      </div>
      <div class="col-md-4 banner">
        <img src="@/assets/banner/b3.png">
      </div>
    </div>
  </div>
</template>
<script>
import moment from "@/moment"

import LottoService from "@/services/lottoService"

export default {
  name: 'HistoryResults',
  data() {
    return {
      data: []
    }
  },
  computed: {
    items() {
      return this.data
    }
  },
  methods: {
    getResults() {
      LottoService.getHistories().then((response) => {
        if (response.status === 'success') {
          this.data = response.data
        }
      })
    },
    splitResult(results) {
      const digit5 = results?.digit5 ?? ''
      return digit5.split('')
    }
  },
  created() {
    this.getResults()
  },
  filters: {
    date(param) {
      return moment(param).format("dddd, MMM DD, YYYY")
    },
    shortdate(param) {
      return moment(param).format("DD/MM/YY")
    },
    result(param, digit) {
      if (param) {
        let results = param
        return results[digit]
      } else {
        return '-'
      }
    }
  },
}

</script>
<style lang="scss">
.h-results {
  width: 760px;
  margin: 0 auto;
  max-width: 100%;
  margin-bottom: 15px;

  .h-head {
    padding: 0 5px;
    background-color: #A90B03;
    padding: 4px;
    border-radius: 5px;

    h2 {
      color: #FFFFFF;
      font-size: 1.2rem;
    }

    img {
      background-color: #FFFFFF;
      border-radius: 20px;
      padding: 2px;
    }
  }

  .h-body {
    margin-top: 10px;

    .h-box {
      margin-right: 0;
      margin-left: 0;
      background-color: #FFFFFF;
      margin: 4px 0;
      font-size: 1.2rem;
      border-radius: 8px;
      border: 1px solid #333333;
      font-weight: 500;

      .h-date {
        color: #333333;
        line-height: 1;
        padding: 8px;
      }

      .h-number {
        color: #333333;
        text-align: right;
        line-height: 1;
        padding: 6px;
        font-size: 1.5rem;
        letter-spacing: 2px;
        font-weight: bold;
        display: flex;
        justify-content: flex-end;

        span {
          border: 1px solid #C2C2C2;
          background-color: #EEEEEE;
          border-radius: 20px;
          display: flex;
          width: 35px;
          height: 35px;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          color: #000000;
          margin: 0 2px;
          font-weight: 500;
        }
      }
    }

    .h-box:hover {
      background-color: #EEEEEE;
      border: 1px solid #00A14B;
    }
  }

  .banners {
    margin-top: 15px;
    margin-left: -5px;
    margin-right: -5px;

    .banner {
      padding-left: 5px;
      padding-right: 5px;

      img {
        border-radius: 10px;
        border: 1px solid #FFFFFF;
      }
    }
  }
}

@media only screen and (max-width:767px) {
  .h-results {
    .h-head, .h-body, .banners {
      width: 80%;
      margin: 15px auto;
    }

    .h-body {
      .h-box {
        .h-number {
          text-align: center;
          font-size: 2.5rem;
          justify-content: center;
        }
      }
    }

    .banners {
      .banner {
        margin-bottom: 10px;
      }
    }
  }
}

@media only screen and (max-width:300px) {
  .h-results {
    .h-head, .h-body {
      width: 95%;
    }

    .h-body {
      .h-box {
        .h-number {
          font-size: 2rem;
        }
      }
    }
  }
}
</style>
